export type MessageType = "user" | "agent" | "system";

export interface ChatMessage {
    id: string;
    type: MessageType;
    author?: string;
    text: string;
    time: string;
}

export const MOCK_CHAT_MESSAGES: ChatMessage[] = [
    { id: "m1", type: "system", text: "Chat session started", time: "14:02" },
    { id: "m2", type: "system", text: "Agent L. Weber has joined the chat", time: "14:02" },
    {
        id: "m3",
        type: "agent",
        author: "L. Weber",
        text: "Hello! I'm L. Weber from the Security Operations team. How can I help you today?",
        time: "14:03",
    },
    {
        id: "m4",
        type: "user",
        author: "You",
        text: "Hi, we received an alert about suspicious login activity on our AD domain controller. The alert ID is SOC-1250. Can you give us more context?",
        time: "14:04",
    },
    {
        id: "m5",
        type: "agent",
        author: "L. Weber",
        text: "I can see SOC-1250 — it's a suspicious login attempt on ad-dc-01. The user appeared to click a phishing link first, then we detected an anomalous AD login from a new location. The severity is currently Medium.",
        time: "14:05",
    },
    {
        id: "m6",
        type: "user",
        author: "You",
        text: "Is the user account compromised? Should we force a password reset?",
        time: "14:06",
    },
    {
        id: "m7",
        type: "agent",
        author: "L. Weber",
        text: "Based on our analysis, the phishing click came from the Q2 IT Helpdesk simulation campaign. The login anomaly is from a new VPN location. I'd recommend a precautionary password reset and checking if MFA was triggered.",
        time: "14:07",
    },
    {
        id: "m8",
        type: "user",
        author: "You",
        text: "Good point. We'll initiate the reset. Any other systems affected?",
        time: "14:08",
    },
    {
        id: "m9",
        type: "agent",
        author: "L. Weber",
        text: "ZTNA has already lowered the trust score for this user. I can see correlated events in the phishing system (PHISH-198). No lateral movement detected by NDR. The blast radius appears contained.",
        time: "14:09",
    },
    {
        id: "m10",
        type: "user",
        author: "You",
        text: "Perfect, thank you for the quick analysis. We'll proceed with the password reset and monitor.",
        time: "14:10",
    },
    {
        id: "m11",
        type: "agent",
        author: "L. Weber",
        text: "You're welcome! I've created ticket TKT-005 to track the phishing follow-up training for all 29 clickers. I'll keep this chat open in case you have further questions.",
        time: "14:11",
    },
];

export const MOCK_AGENT = {
    name: "L. Weber",
    role: "Security Operations Analyst",
    status: "online" as const,
};
